module.exports = __webpack_public_path__ + "static/media/LOGO-ONESTEPAHEAD_HORIZONTAL.85a3ae90.png";